import type { ReactNode } from "react";
import { TopBar } from "./TopBar";
import { SideNav } from "./SideNav";
import { CommandPalette } from "@/components/command-palette";

// Placeholder actions until real per-area registries land. The CommandPalette
// itself owns the Ctrl+K listener so it's mounted at the shell level so the
// shortcut works on every page.
const placeholderActions = [
  { id: "go-quotes", label: "Go to quotes", group: "Navigate", perform: () => { window.location.href = "/quotes"; } },
  { id: "go-jobs", label: "Go to jobs", group: "Navigate", perform: () => { window.location.href = "/jobs"; } },
] as const;

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full flex-col">
      <a href="#main" className="sr-only focus-visible:not-sr-only">Skip to main content</a>
      <TopBar />
      <div className="flex flex-1 overflow-hidden">
        <SideNav />
        <main id="main" className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
      <CommandPalette actions={placeholderActions} />
    </div>
  );
}
